<template >
  <div
      v-if="formObj.general.inputs.je_zasilani_notifikace.val"
  >
    <template v-if="notification.permission == 'granted' && inputModel && notification.isValid">
      <div
          class="d-flex align-items-center"
      >
        <i class="bi bi-check-circle-fill text-success fs-3 me-2"></i>
        <div class="text-success">
          {{$t('input_general.notification.status.set_this')}}
        </div>
      </div>
    </template>

    <template v-else-if="notification.permission == 'granted' && inputModel && !notification.isValid">
      <div
            class="d-flex align-items-center"
      >
        <i class="bi bi bi-question-circle-fill text-warning fs-5 me-2"></i>
        <div class="">
          <span class="">{{$t('input_general.notification.status.set_other')}}</span>
          <button
              class="btn btn-sm btn-outline-secondary ms-2"
              @click.prevent="setupNotification()"
          >
            {{$t('input_general.notification.btn.title')}}
          </button>
        </div>
      </div>
    </template>

    <template v-else-if="notification.permission == 'granted' && !inputModel ">
      <div
          class="d-flex align-items-center"
      >
        <i class="bi bi-bell fs-5 me-2"></i>
        <div class="">
          {{$t('input_general.notification.status.set')}} [set3]
          <button
              class="btn btn-sm btn-outline-secondary ms-2"
              @click.prevent="setupNotification()"
          >
            {{$t('input_general.notification.btn.title')}}
          </button>
        </div>
      </div>
    </template>

    <template v-else-if=" notification.permission != 'granted'">

      <div
          class="d-flex align-items-center"
      >
        <i class="bi bi bi-bell-slash text-danger fs-5 me-2"></i>
        <div class="">
          <span class="text-danger">{{$t('input_general.notification.status.denied')}} [nenastaveno]</span>
          <button
              class="btn btn-sm btn-outline-secondary ms-2"
              @click.prevent="setupNotification()"
          >
            {{$t('input_general.notification.btn.title')}}
          </button>
        </div>
      </div>

      <div
          v-if="1==0"
          class="d-flex align-items-center"
      >
        <i class="bi bi bi-question-circle-fill text-warning fs-5 me-2"></i>
        <div class="">
          <span class="">{{$t('input_general.notification.status.unknown')}}</span>
          <button
              class="btn btn-sm btn-outline-secondary ms-2"
              @click.prevent="setupNotification()"
          >
            {{$t('input_general.notification.btn.title')}}
          </button>
        </div>
      </div>
    </template>
  </div>

  <!--
    <display-debug>
      <template #debugView>inputModel {{inputModel}}</template>
    </display-debug>

    <display-debug>
      <template #debugView>notification: {{notification}}</template>
    </day-debug>

    <display-debug>
      <template #debugView>inputObj {{inputObj}}</template>
    </display-debug>


    <display-debug>
      <template #debugView>formObj {{formObj.general.inputs.je_zasilani_notifikace}}</template>
    </display-debug>
    -->
</template>

<script>

import axios from "axios";
import {initializeApp} from "firebase/app";
import {getMessaging, getToken} from "firebase/messaging";

export default {
  name: "NotificationInput",
  components: {

  },
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": [Object, String, Number],
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      inputModel: null,
      notification: {
        status: false,
        isSet: false,
        isValid: null,
        permission: null
      },
    }
  },
  mounted() {
    this.inputModel = this.inputObj.val;

    this.notification.permission = Notification.permission;
    if (this.notification.permission === 'granted') {
      this.checkPushSubscription();
    }
  },
  methods: {
    async checkPushSubscription() {
      try {
        const app = initializeApp(this.inputObj.templates.fcm_token.firebaseConfig);
        const messaging = getMessaging(app);
        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        // 2. Žádost o povolení v prohlížeči
        const permission = await Notification.requestPermission();

        if (permission === 'granted') {
          const currentToken = await getToken(messaging, {
            vapidKey: this.inputObj.templates.fcm_token.vapidKey,
            serviceWorkerRegistration: registration
          });
          //console.log("[dev.push] checkPushSubscription currentToken", currentToken, this.inputModel)
          //this.notification.isSet = currentToken == this.inputModel;
          this.notification.isSet = true;

          if(
              currentToken == this.inputModel
          ) {
            this.notification.isValid = true;
          }else{
            this.notification.isValid = false;
          }
        }else{
          this.notification.isSet = false;
        }
      } catch (error) {
        this.notification.isSet = null;
        console.error("Chyba při zjišťování odběru:", error);
      }
    },
    async setupNotification() {
      //console.log("[dev.push] setupNotification")
      this.loading = true;

      try {
        // 1. Inicializace Firebase
        //console.log("[dev.push] permission", this.inputObj.templates.fcm_token.firebaseConfig)

        const app = initializeApp(this.inputObj.templates.fcm_token.firebaseConfig);
        const messaging = getMessaging(app);
        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        // 2. Žádost o povolení v prohlížeči
        const permission = await Notification.requestPermission();

        if (permission === 'granted') {
          // 3. Získání unikátního tokenu pro toto zařízení
          const currentToken = await getToken(messaging, {
            vapidKey: this.inputObj.templates.fcm_token.vapidKey,
            serviceWorkerRegistration: registration
          });

          if (currentToken) {
            this.notification.permission = permission;
            //this.token = currentToken;
            // 4. Odeslání tokenu na váš PHP server
            await this.sendTokenToBackend(currentToken);

           // console.log("[dev.push] setupNotification currentToken", currentToken)
            //alert('Notifikace byly úspěšně aktivovány!');
          } else {
            console.warn('Nepodařilo se získat registrační token.');
          }
        } else {
          console.warn('Povolení k notifikacím bylo zamítnuto');
          //alert('Povolení k notifikacím bylo zamítnuto.');
        }
      } catch (error) {
        console.error('Chyba při nastavování FCM:', error);
      } finally {
        this.loading = false;
      }
    },
    async sendTokenToBackend(fcmToken) {
      let formData = new FormData
      formData.append('fcm_token', fcmToken)
      let apiPath = this.getApiConfig('notification.save_fcm_token.path')
      //console.log("dev sendTokenToBackend apiPath", apiPath)
      //console.log("dev sendTokenToBackend", fcmToken)

      axios.defaults.baseURL = this.getBaseRoot();
      axios({
        url: apiPath,
        method: "post",
        withCredentials: true,
        headers: this.getRequestHeader(),
        data: formData
      }).then((res) => {
        this.notification.isSet = true;
          this.notification.isValid = true;
          this.inputModel = fcmToken;
      })
      .catch((err) => {
        console.log("[dev.asyncSearch] catch", err);
      })
      .finally(() => {
        //console.log("DEV tags finally");
      })
    }
  },
  watch: {
    inputObj: {
      handler() {
        this.inputModel = this.inputObj.val;
      },
      deep: true,
      immediate: true
    },
    inputModel( newVal){

    },
  },
};
</script>